import type { Product } from '../types/product'

export function ProductVisual({ product, large = false }: { product: Product; large?: boolean }) {
  const visual = product.officialCategory === '헤어·바디' ? 'hair-care' : product.officialCategory === '화장품·뷰티' ? 'skin-care' : product.officialCategory === '세트상품' ? 'wellness-set' : 'supplement'
  const alt = `${product.seniorFriendlyCategory} 분위기를 표현한 연출 이미지. ${product.name} 실제 제품 사진이 아닙니다.`
  return <figure className={`product-visual ${large ? 'large' : ''}`}>
    <picture>
      <source srcSet={`/images/design/${visual}-420.webp 420w, /images/design/${visual}-800.webp 800w`} type="image/webp" sizes={large ? '(max-width: 640px) 100vw, 520px' : '(max-width: 640px) 115px, 160px'}/>
      <img src={`/images/design/${visual}-420.webp`} alt={alt} loading={large ? 'eager' : 'lazy'} decoding="async" fetchPriority={large ? 'high' : 'auto'}/>
    </picture>
    <figcaption><span>연출 이미지</span><small>실제 포장과 다를 수 있어요</small></figcaption>
  </figure>
}
